<template>
  <!-- Navbar STart -->
  <header id="topnav" class="navigation sticky">
    <div class="" :class="container">
      <!-- Logo container-->
      <div>
        <router-link v-if="logoLight" class="logo" to="/">
          <span class="logo-light-mode">
            <img src="../../assets/images/logo-dark.png" class="l-dark" height="22" alt="">
            <img src="../../assets/images/logo-light.png" class="l-light" height="22" alt="">
          </span>
          <img src="../../assets/images/logo-light.png" height="22" class="logo-dark-mode" alt="">
        </router-link>

        <!-- Logo container-->
        <router-link v-else class="logo" to="/">
          <img src="../../assets/images/logo-dark.png" height="22" class="logo-light-mode" alt="">
          <img src="../../assets/images/logo-light.png" height="22" class="logo-dark-mode" alt="">
        </router-link>
        <!-- Logo End -->
      </div>
      <!-- End Logo container-->

      <!-- Start Mobile Toggle -->
      <div class="menu-extras" @click="handler">
        <div class="menu-item">
          <!-- Mobile menu toggle-->
          <a class="navbar-toggle" id="isToggle" :class="toggle === false ? '' : 'open'">
            <div class="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </a>
          <!-- End mobile menu toggle-->
        </div>
      </div>
      <!-- End Mobile Toggle -->

      <!-- Start Dropdown -->
      <ul class="dropdowns list-inline mb-0">

        <li class="list-inline-item mb-0">
          <a href="javascript:void(0)" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight"
            aria-controls="offcanvasRight">
            <div class="btn btn-icon btn-pills btn-primary"><i data-feather="settings" class="fea icon-sm"></i></div>
          </a>
        </li>

        <li class="list-inline-item mb-0 ms-1">
          <a href="javascript:void(0)" class="btn btn-icon btn-pills btn-primary" data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">
            <i class="uil uil-search"></i>
          </a>
        </li>

        <li class="list-inline-item mb-0 ms-1">
          <div class="dropdown dropdown-primary">
            <button type="button" class="btn btn-pills btn-soft-primary dropdown-toggle p-0" data-bs-toggle="dropdown"
              aria-haspopup="true" aria-expanded="false"><img src="../../assets/images/doctors/01.jpg"
                class="avatar avatar-ex-small rounded-circle" alt=""></button>
            <div class="dropdown-menu dd-menu dropdown-menu-end shadow border-0 mt-3 py-3" style="min-width: 200px;">
              <router-link class="dropdown-item d-flex align-items-center text-dark" to="/doctor-profile">
                <img src="../../assets/images/doctors/01.jpg" class="avatar avatar-md-sm rounded-circle border shadow"
                  alt="">
                <div class="flex-1 ms-2">
                  <span class="d-block mb-1">Calvin Carlo</span>
                  <small class="text-muted">Orthopedic</small>
                </div>
              </router-link>
              <router-link class="dropdown-item text-dark" to="/doctor-dashboard"><span
                  class="mb-0 d-inline-block me-1"><i class="uil uil-dashboard align-middle h6"></i></span>
                Dashboard</router-link>
              <router-link class="dropdown-item text-dark" to="/doctor-profile-setting"><span
                  class="mb-0 d-inline-block me-1"><i class="uil uil-setting align-middle h6"></i></span> Profile
                Settings</router-link>
              <div class="dropdown-divider border-top"></div>
              <router-link class="dropdown-item text-dark" to="/login"><span class="mb-0 d-inline-block me-1"><i
                    class="uil uil-sign-out-alt align-middle h6"></i></span> Logout</router-link>
            </div>
          </div>
        </li>
      </ul>
      <!-- Start Dropdown -->

      <div id="navigation" :class="toggle === false ? 'd-none' : 'd-block'">
        <!-- Navigation Menu-->
        <ul class="navigation-menu nav-left" :class="props.navLight">
          <li class="has-submenu parent-menu-item"
            :class="['/', '/index-one', '/index-two', '/index-three'].includes(activeIndex) ? 'active' : ''">
            <router-link to="" @click="submenu(openMenu === '/index-one' ? '' : '/index-one')">Home<span
                class="menu-arrow d-block d-md-none"></span></router-link><span
              class="menu-arrow d-none d-md-block"></span>
            <ul class="submenu"
              :class="['/', '/index-one', '/index-two', '/index-three'].includes(openMenu) ? 'open' : ''">
              <li :class="activeIndex === '/' ? 'active' : ''"><router-link to="/" class="sub-menu-item">Index
                  One</router-link>
              </li>
              <li :class="activeIndex === '/index-two' ? 'active' : ''"><router-link to="/index-two"
                  class="sub-menu-item">Index Two</router-link></li>
              <li :class="activeIndex === '/index-three' ? 'active' : ''"><router-link to="/index-three"
                  class="sub-menu-item">Index Three</router-link></li>
            </ul>
          </li>

          <li class="has-submenu parent-parent-menu-item"
            :class="['/doctors', '/doctor-dashboard', '/doctor-appointment', '/patient-list', '/doctor-schedule', '/invoices', '/patient-review', '/doctor-messages', '/doctor-profile', '/doctor-profile-setting', '/doctor-chat', '/login', '/signup', '/forgot-password', '/doctor-team-one', '/doctor-team-two', '/doctor-team-three'].includes(activeIndex) ? 'active' : ''">
            <router-link to="" @click="submenu(openMenu === '/doctors' ? '' : '/doctors')">Doctors<span
                class="menu-arrow d-block d-md-none"></span></router-link><span
              class="menu-arrow d-none d-md-block"></span>
            <ul class="submenu"
              :class="['/doctors', '/doctor-dashboard', '/doctor-appointment', '/patient-list', '/doctor-schedule', '/invoices', '/patient-review', '/doctor-messages', '/doctor-profile', '/doctor-profile-setting', '/doctor-chat', '/login', '/signup', '/forgot-password', '/dashboard', '/doctor-team-one', '/doctor-team-two', '/doctor-team-three'].includes(openMenu) ? 'open' : ''">
              <li class="has-submenu parent-menu-item"
                :class="['/dashboard', '/doctor-dashboard', '/doctor-appointment', '/patient-list', '/doctor-schedule', '/invoices', '/patient-review', '/doctor-messages', '/doctor-profile', '/doctor-profile-setting', '/doctor-chat', '/login', '/signup', '/forgot-password'].includes(activeIndex) ? 'active' : ''">
                <router-link to="" @click="submenu(openMenu === '/dashboard' ? '' : '/dashboard')"> Dashboard
                </router-link><span class="submenu-arrow"></span>
                <ul class="submenu"
                  :class="['/dashboard', '/doctor-dashboard', '/doctor-appointment', '/patient-list', '/doctor-schedule', '/invoices', '/patient-review', '/doctor-messages', '/doctor-profile', '/doctor-profile-setting', '/doctor-chat', '/login', '/signup', '/forgot-password',].includes(openMenu) ? 'open' : ''">
                  <li :class="activeIndex === '/doctor-dashboard' ? 'active' : ''"><router-link to="/doctor-dashboard"
                      class="sub-menu-item">Dashboard</router-link></li>
                  <li :class="activeIndex === '/doctor-appointment' ? 'active' : ''"><router-link
                      to="/doctor-appointment" class="sub-menu-item">Appointment</router-link></li>
                  <li :class="activeIndex === '/patient-list' ? 'active' : ''"><router-link to="/patient-list"
                      class="sub-menu-item">Patients</router-link></li>
                  <li :class="activeIndex === '/doctor-schedule' ? 'active' : ''"><router-link to="/doctor-schedule"
                      class="sub-menu-item">Schedule Timing</router-link></li>
                  <li :class="activeIndex === '/invoices' ? 'active' : ''"><router-link to="/invoices"
                      class="sub-menu-item">Invoices</router-link></li>
                  <li :class="activeIndex === '/patient-review' ? 'active' : ''"><router-link to="/patient-review"
                      class="sub-menu-item">Reviews</router-link></li>
                  <li :class="activeIndex === '/doctor-messages' ? 'active' : ''"><router-link to="/doctor-messages"
                      class="sub-menu-item">Messages</router-link></li>
                  <li :class="activeIndex === '/doctor-profile' ? 'active' : ''"><router-link to="/doctor-profile"
                      class="sub-menu-item">Profile</router-link></li>
                  <li :class="activeIndex === '/doctor-profile-setting' ? 'active' : ''"><router-link
                      to="/doctor-profile-setting" class="sub-menu-item">Profile Settings</router-link></li>
                  <li :class="activeIndex === '/doctor-chat' ? 'active' : ''"><router-link to="/doctor-chat"
                      class="sub-menu-item">Chat</router-link></li>
                  <li :class="activeIndex === '/login' ? 'active' : ''"><router-link to="/login"
                      class="sub-menu-item">Login</router-link></li>
                  <li :class="activeIndex === '/signup' ? 'active' : ''"><router-link to="/signup"
                      class="sub-menu-item">Sign Up</router-link></li>
                  <li :class="activeIndex === '/forgot-password' ? 'active' : ''"><router-link to="/forgot-password"
                      class="sub-menu-item">Forgot Password</router-link></li>
                </ul>
              </li>
              <li :class="activeIndex === '/doctor-team-one' ? 'active' : ''"><router-link to="/doctor-team-one"
                  class="sub-menu-item">Doctors One</router-link></li>
              <li :class="activeIndex === '/doctor-team-two' ? 'active' : ''"><router-link to="/doctor-team-two"
                  class="sub-menu-item">Doctors Two</router-link></li>
              <li :class="activeIndex === '/doctor-team-three' ? 'active' : ''"><router-link to="/doctor-team-three"
                  class="sub-menu-item">Doctors Three</router-link></li>
            </ul>
          </li>

          <li class="has-submenu parent-menu-item"
            :class="['/patients', '/patient-dashboard', '/patient-profile', '/booking-appointment', '/patient-invoice'].includes(activeIndex) ? 'active' : ''">
            <router-link to="" @click="submenu(openMenu === '/patients' ? '' : '/patients')">Patients<span
                class="menu-arrow d-block d-md-none"></span></router-link><span
              class="menu-arrow d-none d-md-block"></span>
            <ul class="submenu"
              :class="['/patients', '/patient-dashboard', '/patient-profile', '/booking-appointment', '/patient-invoice'].includes(openMenu) ? 'open' : ''">
              <li :class="activeIndex === '/patient-dashboard' ? 'active' : ''"><router-link to="/patient-dashboard"
                  class="sub-menu-item">Dashboard</router-link></li>
              <li :class="activeIndex === '/patient-profile' ? 'active' : ''"><router-link to="/patient-profile"
                  class="sub-menu-item">Profile</router-link></li>
              <li :class="activeIndex === '/booking-appointment' ? 'active' : ''"><router-link to="/booking-appointment"
                  class="sub-menu-item">Book Appointment</router-link></li>
              <li :class="activeIndex === '/patient-invoice' ? 'active' : ''"><router-link to="/patient-invoice"
                  class="sub-menu-item">Invoice</router-link></li>
            </ul>
          </li>

          <li class="has-submenu parent-menu-item"
            :class="['/Pharmacys', '/pharmacy', '/pharmacy-shop', '/pharmacy-product-detail', '/pharmacy-shop-cart', '/pharmacy-checkout', '/pharmacy-account'].includes(activeIndex) ? 'active' : ''">
            <router-link to="" @click="submenu(openMenu === '/Pharmacys' ? '' : '/Pharmacys')">Pharmacy<span
                class="menu-arrow"></span></router-link><span class="menu-arrow d-block d-md-none"></span>
            <ul class="submenu"
              :class="['/Pharmacys', '/pharmacy', '/pharmacy-shop', '/pharmacy-product-detail', '/pharmacy-shop-cart', '/pharmacy-checkout', '/pharmacy-account'].includes(openMenu) ? 'open' : ''">
              <li :class="activeIndex === '/pharmacy' ? 'active' : ''"><router-link to="/pharmacy"
                  class="sub-menu-item">Pharmacy</router-link></li>
              <li :class="activeIndex === '/pharmacy-shop' ? 'active' : ''"><router-link to="/pharmacy-shop"
                  class="sub-menu-item">Shop</router-link></li>
              <li :class="activeIndex === '/pharmacy-product-detail' ? 'active' : ''"><router-link
                  to="/pharmacy-product-detail" class="sub-menu-item">Medicine Detail</router-link></li>
              <li :class="activeIndex === '/pharmacy-shop-cart' ? 'active' : ''"><router-link to="/pharmacy-shop-cart"
                  class="sub-menu-item">Shop Cart</router-link></li>
              <li :class="activeIndex === '/pharmacy-checkout' ? 'active' : ''"><router-link to="/pharmacy-checkout"
                  class="sub-menu-item">Checkout</router-link></li>
              <li :class="activeIndex === '/pharmacy-account' ? 'active' : ''"><router-link to="/pharmacy-account"
                  class="sub-menu-item">Account</router-link></li>
            </ul>
          </li>

          <li class="has-submenu parent-parent-menu-item"
            :class="['/pages', '/aboutus', '/departments', '/faqs', '/blog', '/blogs', '/blog-detail', '/terms', '/privacy', '/error'].includes(activeIndex) ? 'active' : ''">
            <router-link to="" @click="submenu(openMenu === '/pages' ? '' : '/pages')">Pages<span
                class="menu-arrow d-block d-md-none"></span></router-link><span
              class="menu-arrow d-none d-md-block"></span>
            <ul class="submenu"
              :class="['/pages', '/aboutus', '/departments', '/faqs', '/blog', '/blogs', '/blog-detail', '/terms', '/privacy', '/error'].includes(openMenu) ? 'open' : ''">
              <li :class="activeIndex === '/aboutus' ? 'active' : ''"><router-link to="/aboutus" class="sub-menu-item">
                  About Us</router-link></li>
              <li :class="activeIndex === '/departments' ? 'active' : ''"><router-link to="/departments"
                  class="sub-menu-item">Departments</router-link></li>
              <li :class="activeIndex === '/faqs' ? 'active' : ''"><router-link to="/faqs"
                  class="sub-menu-item">FAQs</router-link></li>
              <li class="has-submenu parent-menu-item"
                :class="['/blog', '/blogs', '/blog-detail'].includes(activeIndex) ? 'active' : ''">
                <router-link to="" @click="submenu(openMenu === '/blog' ? '' : '/blog')" class="menu-item"> Blogs
                </router-link><span class="submenu-arrow"></span>
                <ul class="submenu" :class="['/blog', '/blogs', '/blog-detail'].includes(openMenu) ? 'open' : ''">
                  <li :class="activeIndex === '/blogs' ? 'active' : ''"><router-link to="/blogs"
                      class="sub-menu-item">Blogs</router-link></li>
                  <li :class="activeIndex === '/blog-detail' ? 'active' : ''"><router-link to="/blog-detail"
                      class="sub-menu-item">Blog Details</router-link></li>
                </ul>
              </li>
              <li :class="activeIndex === '/terms' ? 'active' : ''"><router-link to="/terms" class="sub-menu-item">Terms
                  & Policy</router-link></li>
              <li :class="activeIndex === '/privacy' ? 'active' : ''"><router-link to="/privacy"
                  class="sub-menu-item">Privacy Policy</router-link></li>
              <li :class="activeIndex === '/error' ? 'active' : ''"><router-link to="/error" class="sub-menu-item">404
                  !</router-link></li>
            </ul>
          </li>

          <li :class="activeIndex === '/contact' ? 'active' : ''"><router-link to="/contact"
                  class="sub-menu-item">Contact</router-link></li>
        </ul><!--end navigation menu-->
      </div><!--end navigation-->
    </div><!--end container-->
  </header><!--end header-->
  <!-- Navbar End -->

  <!-- Offcanvas Start -->
  <div class="offcanvas offcanvas-end shadow border-0" tabindex="-1" id="offcanvasRight"
    aria-labelledby="offcanvasRightLabel">
    <div class="offcanvas-header p-4 border-bottom offcanvas-header">
      <h5 id="offcanvasRightLabel" class="mb-0">
        <img src="../../assets/images/logo-dark.png" height="22" class="light-version" alt="">
        <img src="https://doctris-react-landing.vercel.app/static/media/mobile-app.5c21d3b04b0ac91015c7d41d7e8e4cad.svg"
          height="22" class="dark-version" alt="">
      </h5>
      <button type="button" class="btn-close d-flex align-items-center text-dark" data-bs-dismiss="offcanvas"
        aria-label="Close"><i class="uil uil-times fs-4"></i></button>
    </div>
    <div class="offcanvas-body">
      <div class="row">
        <div class="col-12">
          <div>
            <div>
              <img
                src="https://doctris-react-landing.vercel.app/static/media/mobile-app.5c21d3b04b0ac91015c7d41d7e8e4cad.svg"
                alt="" class="w-75 h-auto mx-auto d-block">
            </div>
            <h5 class="my-4">Get in touch!</h5>
            <form>
              <div class="row">
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Your Name <span class="text-danger">*</span></label>
                    <input name="name" id="name" type="text" class="form-control border rounded"
                      placeholder="First Name :">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Your Email <span class="text-danger">*</span></label>
                    <input name="email" id="email" type="email" class="form-control border rounded"
                      placeholder="Your email :">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Subject</label>
                    <input name="subject" id="subject" class="form-control border rounded" placeholder="Your subject :">
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mb-3">
                    <label class="form-label">Comments<span class="text-danger">*</span></label>
                    <textarea name="comments" id="comments" rows="4" class="form-control border rounded"
                      placeholder="Your Message :"></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <button type="submit" id="submit" name="send" class="btn btn-primary">Send Message</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="offcanvas-footer p-4 border-top text-center">
      <ul class="list-unstyled social-icon social mb-0">
        <li v-for="item in icons" :key="item" class="list-inline-item mb-0 me-1"><a :href="item.link" target="_blank"
            class="rounded"><i :class="item.icon" title="Buy Now"></i></a></li>
      </ul><!--end icon-->
    </div>
  </div>
  <!-- Offcanvas End -->



  <!-- Offcanvas Start -->
  <div class="offcanvas offcanvas-top" tabindex="-1" id="offcanvasTop">
    <div class="offcanvas-body d-flex align-items-center align-items-center">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="text-center">
              <h4>Search now.....</h4>
              <div class="subcribe-form mt-4">
                <form>
                  <div class="mb-0">
                    <input type="text" id="help" name="name" class="border rounded-pill" required=""
                      placeholder="Search">
                    <button type="submit" class="btn btn-pills btn-primary">Search</button>
                  </div>
                </form>
              </div>
            </div>
          </div><!--end col-->
        </div><!--end row-->
      </div><!--end container-->
    </div>
  </div>
  <!-- Offcanvas End -->
</template>

<script setup>
import feather from 'feather-icons';
import { ref, onMounted, onUnmounted, computed, defineProps } from 'vue';

const toggle = ref(false);
const menu = ref(true);
const current = ref(''); // Define current as a ref
const props = defineProps({
  navLight: {
    type: String,
    required: true
  },
  logoLight: {
    type: String,
    required: true
  },
  container: {
    type: String,
    required: true
  },
});
const activeIndex = computed(() => window.location.pathname);
const openMenu = ref('');

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  window.addEventListener('scroll', onscroll);
  feather.replace();
  scrollToTop()

});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  window.removeEventListener('scroll', onscroll);
});

const icons = ref([
  {
    link: 'https://1.envato.market/doctris-vue',
    icon: 'uil uil-shopping-cart align-middle'
  },
  {
    link: 'https://dribbble.com/shreethemes',
    icon: 'uil uil-dribbble align-middle'
  },
  {
    link: 'https://www.behance.net/shreethemes',
    icon: 'uil uil-behance align-middle'
  },
  {
    link: 'https://www.facebook.com/shreethemes',
    icon: 'uil uil-facebook-f align-middle'
  },
  {
    link: 'https://www.instagram.com/shreethemes/',
    icon: 'uil uil-instagram align-middle'
  },
  {
    link: 'https://twitter.com/shreethemes',
    icon: 'uil uil-twitter align-middle'
  },
  {
    link: 'mailto:support@shreethemes.in',
    icon: 'uil uil-envelope align-middle'
  },
  {
    link: 'https://shreethemes.in',
    icon: 'uil uil-globe align-middle'
  },
])

function handler() {
  toggle.value = !toggle.value;
}

function submenu(item) {
  menu.value = !menu.value;
  openMenu.value = item;
}

function handleScroll() {
  const navbar = document.getElementById("topnav");
  if (window.scrollY >= 50) {
    navbar.classList.add("nav-sticky");
  } else {
    navbar.classList.remove("nav-sticky");
  }
}


function onscroll() {
  const sections = document.querySelectorAll("section");
  const navItems = document.querySelectorAll("nav.container.collapse ul li");
  let currentSectionId = ''; // Define a variable to store the current section's id
  sections.forEach((section) => {
    const sectionTop = section.offsetTop;
    if (window.pageYOffset >= sectionTop - 60) {
      currentSectionId = section.getAttribute("id");
    }
  });
  navItems.forEach((li) => {
    if (li.classList.contains(currentSectionId)) {
      li.classList.add("active");
    } else {
      li.classList.remove("active");
    }
  });
  current.value = currentSectionId; // Update the current ref
}

function scrollToTop() {
  window.scrollTo(0, 0);
}


</script>

<style lang="scss" scoped></style>